/**
 * Prototype v1.4 navbar interactions
 */
(function () {
  var root = document.querySelector("[data-td-nav]");
  if (!root || root.getAttribute("data-td-nav-ready") === "1") {
    return;
  }
  root.setAttribute("data-td-nav-ready", "1");

  var items = root.querySelectorAll(".td-nav__item[data-menu]");
  var panels = root.querySelectorAll(".td-nav__panel[data-panel]");
  var burger = root.querySelector("[data-td-burger]");
  var mobile = root.querySelector("[data-td-mobile]");
  var user = root.querySelector("[data-td-user]");
  var closeTimer = null;
  var desktopQuery = window.matchMedia("(min-width: 1024px)");

  function clearCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeAllPanels() {
    items.forEach(function (item) {
      item.classList.remove("is-active");
    });
    panels.forEach(function (panel) {
      panel.classList.remove("is-open");
      panel.hidden = true;
    });
    root.classList.remove("is-open");
  }

  function openPanel(menuKey) {
    clearCloseTimer();
    items.forEach(function (item) {
      var match = item.getAttribute("data-menu") === menuKey;
      item.classList.toggle("is-active", match);
    });
    panels.forEach(function (panel) {
      var match = panel.getAttribute("data-panel") === menuKey;
      panel.hidden = !match;
      panel.classList.toggle("is-open", match);
    });
    root.classList.add("is-open");
  }

  function scheduleClose() {
    clearCloseTimer();
    closeTimer = setTimeout(closeAllPanels, 130);
  }

  items.forEach(function (item) {
    var menuKey = item.getAttribute("data-menu");
    item.addEventListener("mouseenter", function () {
      if (!desktopQuery.matches) {
        return;
      }
      openPanel(menuKey);
    });
    item.addEventListener("mouseleave", function () {
      if (!desktopQuery.matches) {
        return;
      }
      scheduleClose();
    });
  });

  panels.forEach(function (panel) {
    panel.addEventListener("mouseenter", function () {
      if (!desktopQuery.matches) {
        return;
      }
      clearCloseTimer();
      var menuKey = panel.getAttribute("data-panel");
      openPanel(menuKey);
    });
    panel.addEventListener("mouseleave", function () {
      if (!desktopQuery.matches) {
        return;
      }
      scheduleClose();
    });
  });

  if (burger && mobile) {
    burger.addEventListener("click", function () {
      var willOpen = !root.classList.contains("is-mobile-open");
      root.classList.toggle("is-mobile-open", willOpen);
      mobile.hidden = !willOpen;
      closeAllPanels();
    });
  }

  if (user) {
    var avatar = user.querySelector(".td-nav__user-avatar");
    if (avatar) {
      avatar.addEventListener("click", function (event) {
        event.stopPropagation();
        user.classList.toggle("is-open");
      });
    }
    document.addEventListener("click", function () {
      user.classList.remove("is-open");
    });
  }

  window.addEventListener(
    "scroll",
    function () {
      root.classList.toggle("is-scrolled", window.scrollY > 10);
    },
    { passive: true }
  );

  window.addEventListener("resize", function () {
    if (!desktopQuery.matches) {
      closeAllPanels();
    } else if (mobile) {
      root.classList.remove("is-mobile-open");
      mobile.hidden = true;
    }
  });
})();
